import React from 'react';
import { Tooltip } from 'react-tooltip';
import { useTranslation } from 'react-i18next';
import { shape, number } from 'prop-types';
import { useSelector } from 'react-redux';
import { get } from 'lodash-es';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserFriends } from '@fortawesome/pro-duotone-svg-icons';

import { userIdSelector } from 'common/selectors';

export const PersonInChargeMask = ({ video }) => {
  const { t } = useTranslation();
  const currentUserId = useSelector(userIdSelector);

  return currentUserId === get(video, 'responsibleUserId') && currentUserId !== get(video, 'uploaderUserId') ? (
    <div data-e2e="person-in-charge-mask">
      <div
        data-tooltip-content={`${t('in_charge_of_video')}`}
        data-tooltip-id="personInChargeTooltip"
        data-delay-show={1000}
        className="person-in-charge-mask"
      >
        <FontAwesomeIcon className="video-metadata-icon" icon={faUserFriends} />
      </div>
      <Tooltip id="personInChargeTooltip" place="bottom" effect="solid" type="light" globalEventOff="click" />
    </div>
  ) : null;
};

PersonInChargeMask.propTypes = {
  video: shape({
    uploaderUserId: number,
    responsibleUserId: number,
  }),
};
